import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: 8,
        padding: '19px 16px',
    },
    icon: {
        width: 24,
        height: 24,
        borderRadius: '50%',
    },
    cardNumber: {
        marginLeft: 16,
        flexGrow: 1,
        width: 100,
        height: 20,
    },
    badge: {
        width: 80,
        height: 24,
        borderRadius: 12,
    },
}));

const CardSkeleton = () => {
    const classes = useStyles();

    return (
        <div className={classes.list}>
            <div className={classes.container}>
                <Skeleton variant="circle" className={classes.icon} />
                <div style={{ marginLeft: 16, flexGrow: 1 }}>
                    <Skeleton variant="text" className={classes.cardNumber} />
                </div>
                <Skeleton variant="rect" className={classes.badge} />
            </div>
            <div className={classes.container}>
                <Skeleton variant="circle" className={classes.icon} />
                <div style={{ marginLeft: 16, flexGrow: 1 }}>
                    <Skeleton variant="text" className={classes.cardNumber} />
                </div>
                <Skeleton variant="rect" className={classes.badge} />
            </div>
            <div className={classes.container}>
                <Skeleton variant="circle" className={classes.icon} />
                <div style={{ marginLeft: 16, flexGrow: 1 }}>
                    <Skeleton variant="text" className={classes.cardNumber} />
                </div>
                <Skeleton variant="rect" className={classes.badge} />
            </div>
        </div>
    );
};

export default CardSkeleton;
